export default "/images/2.png?fa9f0e38d15ac2e623e06507f23646f8";